export const groupTypes = [
  { reference: 'distributor', title: 'Distributor' },
  { reference: 'sub_distributor', title: 'Sub-distributor' },
  { reference: 'partner', title: 'Partner' },
  { reference: 'customer', title: 'Customer' },
  { reference: 'sub_distributor_partner', title: 'Sub-distributor Partner' },
];
